import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const useAdminCanMakeChanges = () => {
  const { data } = useUser();
  const { canAdminMakeChanges } = getUserProperties(data);

  return canAdminMakeChanges;
};

export default useAdminCanMakeChanges;
